import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const MyPrices = lazy(() => import("@/pages/MyPrices"));

export const Route = createFileRoute("/mina-elpriser")({
  head: () => seoHead("/mina-elpriser"),
  component: () => <MyPrices />,
});
